// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactInfoPopup_content_container__OFcei {
  display: flex;
  justify-content: space-between;
  max-width: 100% !important;
}

.ContactInfoPopup_MuiOutlinedInput-notchedOutline__GoUif {
  background-color: var(--color-theme-silver) !important;
}

.ContactInfoPopup_btn_copy_data__QWqyQ {
  flex: 2 1;
  font-weight: 600 !important;
  color: var(--color-font-10) !important;
  height: 40px;
  min-width: 350px !important;
  line-height: 0px !important;
}

.ContactInfoPopup_contact_container__-3rUz {
  display: flex;
  flex-direction: column;
  width: 49%;
}

.ContactInfoPopup_TwoInputs__GB97c {
  display: flex;
  justify-content: space-between;
}
.ContactInfoPopup_subInput__\\+bdsL {
  width: 49% !important ;
  max-width: 49% !important;
  min-width: 0 !important;
}

.ContactInfoPopup_countrySelect__xMc9m {
  width: 100% !important;
  min-width: 145px !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/ContactInfoPopup/ContactInfoPopup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,SAAO;EACP,2BAA2B;EAC3B,sCAAsC;EACtC,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B","sourcesContent":[".content_container {\n  display: flex;\n  justify-content: space-between;\n  max-width: 100% !important;\n}\n\n.MuiOutlinedInput-notchedOutline {\n  background-color: var(--color-theme-silver) !important;\n}\n\n.btn_copy_data {\n  flex: 2;\n  font-weight: 600 !important;\n  color: var(--color-font-10) !important;\n  height: 40px;\n  min-width: 350px !important;\n  line-height: 0px !important;\n}\n\n.contact_container {\n  display: flex;\n  flex-direction: column;\n  width: 49%;\n}\n\n.TwoInputs {\n  display: flex;\n  justify-content: space-between;\n}\n.subInput {\n  width: 49% !important ;\n  max-width: 49% !important;\n  min-width: 0 !important;\n}\n\n.countrySelect {\n  width: 100% !important;\n  min-width: 145px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_container": `ContactInfoPopup_content_container__OFcei`,
	"MuiOutlinedInput-notchedOutline": `ContactInfoPopup_MuiOutlinedInput-notchedOutline__GoUif`,
	"btn_copy_data": `ContactInfoPopup_btn_copy_data__QWqyQ`,
	"contact_container": `ContactInfoPopup_contact_container__-3rUz`,
	"TwoInputs": `ContactInfoPopup_TwoInputs__GB97c`,
	"subInput": `ContactInfoPopup_subInput__+bdsL`,
	"countrySelect": `ContactInfoPopup_countrySelect__xMc9m`
};
export default ___CSS_LOADER_EXPORT___;
